export const foodDataMain = () =>{

  const Data = [
    {
      id: 1,
      name: "Egg Roll",
      image: "https://img.freepik.com/free-photo/egg-roll-fried-spring-rolls-white-plate-thai-food_1150-21492.jpg",
      price: 95,
      avgRating: 4,
      reviewCount: 258,
      orderTime: "15-20 minutes",
      reviews: [
        "Crispy and delicious!",
        "Worth the price!",
        "Perfectly cooked eggs, loved it!"
      ]
  },
  {
      id: 2,
      name: "Chicken Lollipop",
      image: "https://img.freepik.com/free-photo/high-angle-shot-delicious-hot-spicy-dish-called-drums-heaven-table_181624-50861.jpg",
      price: 285,
      avgRating: 4,
      reviewCount: 119,
      orderTime: "20-25 minutes",
      reviews: [
          "Tender and spicy!",
          "Great appetizer for parties!",
          "Could use a bit more flavor."
      ]
  },
  {
      id: 3,
      name: "Chicken 65",
      image: "https://img.freepik.com/free-photo/side-view-stewed-meatballs-with-tomato-sauce-bell-pepper-spring-onion-mint-plate_141793-5117.jpg",
      price: 225,
      avgRating: 5,
      reviewCount: 112,
      orderTime: "25-30 minutes",
      reviews: [
          "Authentic taste, loved the spices!",
          "Best Chicken 65 I ever had!",
          "Highly recommended for spice lovers."
      ]
  },
  {
      id: 4,
      name: "Paneer Chilly",
      image: "https://img.freepik.com/premium-photo/paneer-jalfrezi-cottage-cheese-cooked-with-peppers-onion_466689-82020.jpg",
      price: 265,
      avgRating: 4,
      reviewCount: 123,
      orderTime: "20-25 minutes",
      reviews: [
          "Paneer was fresh and soft!",
          "A perfect blend of spices and vegetables.",
          "Could be a bit more spicy."
      ]
  },
  {
      id: 5,
      name: "Paneer Pakoda",
      image: "https://img.freepik.com/premium-photo/crispy-paneer-popcorn-is-popular-party-snack-appetiser-selective-focus_466689-38830.jpg",
      price: 245,
      avgRating: 4,
      reviewCount: 139,
      orderTime: "15-20 minutes",
      reviews: [
          "Crunchy and flavorful!",
          "Paneer pieces are perfectly sized.",
          "Best snack for tea time."
      ]
  },
  {
      id: 6,
      name: "Veg Pakoda",
      image: "https://img.freepik.com/free-photo/delicious-veggie-dishes-still-life_23-2151160841.jpg",
      price: 125,
      avgRating: 4,
      reviewCount: 150,
      orderTime: "15-20 minutes",
      reviews: [
          "Crispy and light!",
          "Great for health-conscious people.",
          "Good value for money."
      ]
  },
  {
      id: 7,
      name: "Fried Rice",
      image: "https://img.freepik.com/premium-photo/indo-chinese-chicken-fried-rice-vegetables-served-white-ceramic-bowl-selective-focus_466689-74618.jpg",
      price: 190,
      avgRating: 4,
      reviewCount: 300,
      orderTime: "25-30 minutes",
      reviews: [
          "Rice was perfectly cooked!",
          "Loved the veggies in it.",
          "Great portion size."
      ]
  },
  {
      id: 8,
      name: "Masala Dosa",
      image: "https://img.freepik.com/premium-photo/masala-dosa-served-with-coconut-chutney-sambar-south-indian-breakfast_57665-5275.jpg",
      price: 130,
      avgRating: 5,
      reviewCount: 215,
      orderTime: "20-25 minutes",
      reviews: [
          "Authentic South Indian taste!",
          "Crispy dosa with delicious filling.",
          "Sambar was a bit tangy but good."
      ]
  },
  {
      id: 9,
      name: "Tandoori Chicken",
      image: "https://img.freepik.com/free-photo/chicken-tandoori-served-green-chutney-with-onion-slices-lemon-plate_57665-3796.jpg",
      price: 350,
      avgRating: 5,
      reviewCount: 350,
      orderTime: "30-35 minutes",
      reviews: [
          "Juicy and smoky!",
          "Best tandoori chicken in town!",
          "Served hot and fresh."
      ]
  },
  {
      id: 10,
      name: "Mutton Biryani",
      image: "https://img.freepik.com/free-photo/delicious-indian-dish-served-plate_114579-1121.jpg",
      price: 450,
      avgRating: 5,
      reviewCount: 400,
      orderTime: "40-45 minutes",
      reviews: [
          "Aromatic and flavorful!",
          "Mutton was tender and juicy.",
          "Worth every penny!"
      ]
  },
  {
      id: 11,
      name: "Veg Biryani",
      image: "https://img.freepik.com/premium-photo/vegetarian-biryani-delicious-vegetables-rice-plate-indian-food_79782-3165.jpg",
      price: 120,
      avgRating: 4,
      reviewCount: 170,
      orderTime: "25-30 minutes",
      reviews: [
          "Perfect for vegetarians!",
          "Rice was aromatic and tasty.",
          "Loved the spice level."
      ]
  },
  {
      id: 12,
      name: "Hakka Noodles",
      image: "https://img.freepik.com/premium-photo/hakka-noodles-is-indian-style-chinese-recipe-kids-or-college-students-great-snack-meal-vegetarian-egg-chicken-preparation_466689-62219.jpg",
      price: 175,
      avgRating: 4,
      reviewCount: 155,
      orderTime: "20-25 minutes",
      reviews: [
          "Noodles were well-cooked!",
          "Good mix of veggies and spices.",
          "Could use a bit more sauce."
      ]
  },
  {
      id: 13,
      name: "Pani Puri",
      image: "https://img.freepik.com/free-photo/pani-puri-golgappa-spicy-indian-snack-with-chutneys_107250-10068.jpg",
      price: 50,
      avgRating: 5,
      reviewCount: 180,
      orderTime: "10-15 minutes",
      reviews: [
          "Crispy puris and tangy water!",
          "Perfect street food experience.",
          "Loved the spicy flavor."
      ]
  },
  {
      id: 14,
      name: "Butter Chicken",
      image: "https://img.freepik.com/free-photo/indian-chicken-butter-gravy-masala-served-plate-selective-focus_466689-76679.jpg",
      price: 400,
      avgRating: 5,
      reviewCount: 420,
      orderTime: "30-35 minutes",
      reviews: [
          "Creamy and rich flavor!",
          "Perfect with butter naan.",
          "Great portion size."
      ]
  },
  {
      id: 15,
      name: "Palak Paneer",
      image: "https://img.freepik.com/premium-photo/palak-paneer-cottage-cheese-cooked-spinach-curry-healthy-eating-concept_466689-83160.jpg",
      price: 300,
      avgRating: 4,
      reviewCount: 210,
      orderTime: "25-30 minutes",
      reviews: [
          "Spinach gravy was amazing!",
          "Paneer cubes were soft and fresh.",
          "Could use a bit more seasoning."
      ]
  },
  {
      id: 16,
      name: "Chicken Biryani",
      image: "https://img.freepik.com/free-photo/close-up-shot-delicious-freshly-prepared-dhokla_181624-34771.jpg",
      price: 200,
      avgRating: 4,
      reviewCount: 125,
      orderTime: "30-35 minutes",
      reviews: [
          "Classic chicken biryani taste!",
          "Chicken pieces were well-marinated.",
          "Great spice level."
      ]
  },
  {
      id: 17,
      name: "Egg Biryani",
      image: "https://img.freepik.com/free-photo/idly-sambhar-vada-traditional-south-indian-breakfast_57665-3758.jpg",
      price: 150,
      avgRating: 5,
      reviewCount: 300,
      orderTime: "20-25 minutes",
      reviews: [
          "Eggs were perfectly cooked!",
          "Great blend of spices and rice.",
          "Affordable and tasty."
      ]
  },
  {
    id: 18,
    name: "Shahi Paneer",
    image: "https://img.freepik.com/free-photo/shahi-paneer-curry-cream-rich-vegetarian-dish-indian-cuisine_127657-1011.jpg",
    price: 350,
    avgRating: 4,
    reviewCount: 230,
    orderTime: "30-40 mins",
    reviews: [
        "Rich and creamy! Perfect with naan.",
        "The best Shahi Paneer I've ever had.",
        "Great flavor but could use a bit more spice."
    ]
},
{
    id: 19,
    name: "Momos",
    image: "https://img.freepik.com/premium-photo/veg-steamed-dumplings-known-as-momos-served-chilli-sauce_466689-53054.jpg",
    price: 120,
    avgRating: 5,
    reviewCount: 400,
    orderTime: "20-30 mins",
    reviews: [
        "Fresh and delicious! Loved the dipping sauce.",
        "Perfectly steamed, and the filling was flavorful.",
        "Highly recommend trying these momos!"
    ]
},
{
    id: 20,
    name: "Rajma Chawal",
    image: "https://img.freepik.com/premium-photo/rajma-chawal-healthy-nutritious-indian-lunch_466689-70489.jpg",
    price: 180,
    avgRating: 4,
    reviewCount: 210,
    orderTime: "25-35 mins",
    reviews: [
        "Tastes just like homemade Rajma Chawal.",
        "Comfort food at its best.",
        "Could use a bit more spice, but overall amazing."
    ]
},
{
    id: 21,
    name: "Gulab Jamun",
    image: "https://img.freepik.com/free-photo/gulab-jamun-made-khoya-served-bowl_57665-1647.jpg",
    price: 60,
    avgRating: 5,
    reviewCount: 180,
    orderTime: "15-20 mins",
    reviews: [
        "Soft and perfectly sweetened Gulab Jamuns.",
        "Best dessert to end a meal!",
        "Melt-in-your-mouth deliciousness."
    ]
}
  ];
  



  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(Data);
    }, 500); 
  });
};


 